import { FC, useEffect } from 'react';
import { useUserContext } from '@edikk-edikk/shared';
import { useMenuState, useButtonForAdvertContactsControl } from '#baseMenu/hooks';
import { LinkToManage, ReviewCheckToggle, AdvertContactsToggle } from '#baseMenu/components';
import { useAdvertContactsState } from '#advertContacts/hooks';

const MiddleButton: FC = () => {
  const { isAuth } = useUserContext();
  const { isVisibleButtonForAdvertContacts } = useMenuState();
  const { show, hide } = useButtonForAdvertContactsControl();
  const { contactData } = useAdvertContactsState();

  useEffect(() => {
    if (contactData && !contactData.isEmpty) {
      show();
    } else {
      hide();
    }
  }, [contactData, hide, show]);

  if (isVisibleButtonForAdvertContacts) {
    return <AdvertContactsToggle />;
  }

  if (isAuth) {
    return <LinkToManage />;
  }

  return <ReviewCheckToggle />;
};

export { MiddleButton };
